export const reports = {
  PDF: 1,
  EXCEL: 2
};